import React from 'react';
import './Symbols.css';

export const Tickmark = (props) => {
  return (
        <svg width={props.width} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle className="path circle" fill="#73AF55" cx="65.1" cy="65.1" r="62.1"/>
        <polyline className="path check" fill="none" stroke="#FFF" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg>
  )
}

export const Cross = (props) => {
    return (
        <svg width={props.width} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle className="path circle" fill="#D06079" cx="65.1" cy="65.1" r="62.1"/>
        <line className="path line" fill="none" stroke="#FFF" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
        <line className="path line" fill="none" stroke="#FFF" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
        </svg>
    )
}
